/**
 * <ReferralHowItWorks> — les trois étapes du parrainage (organism).
 *
 * Les mots sont ceux du legacy (`ReferralCodeScreen`) : partager, ce que gagne le filleul, ce que
 * gagne le parrain. Seul le montant arrive en prop — aucun chiffre métier ne vit dans le DS.
 *
 * Trois étapes font UNE carte à trois lignes, pas trois cartes.
 */
import { CardList, CardListRow } from "../../molecules/CardList"
import { ReferralHowItWorksStep } from "../../molecules/ReferralHowItWorksStep"

export type ReferralHowItWorksProps = {
    /** « 50€ » — ce que le parrain gagne par filleul activé. */
    rewardLabel: string
    testID?: string
}

export function ReferralHowItWorks(props: ReferralHowItWorksProps) {
    const { rewardLabel, testID } = props

    return (
        <CardList testID={testID}>
            <CardListRow>
                <ReferralHowItWorksStep iconName="share-alt" text="Partagez votre lien d'invitation" />
            </CardListRow>
            <CardListRow>
                <ReferralHowItWorksStep
                    iconName="user-plus"
                    text="Votre filleul s'inscrit et bénéficie d'"
                    boldText="1 séance découverte gratuite de 30 min"
                />
            </CardListRow>
            <CardListRow>
                <ReferralHowItWorksStep
                    iconName="euro-sign"
                    text="Vous gagnez "
                    boldText={`${rewardLabel} dès qu'il active son abonnement`}
                />
            </CardListRow>
        </CardList>
    )
}
